var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('SearchObject', {
    ref: "search",
    attrs: {
      "disabled": _vm.disabled,
      "value": _vm.value,
      "base-url": _vm.baseUrl,
      "label": _vm.label || _vm.$translate('select_shipment'),
      "additional-params": Object.assign({
        ordering: '-shipment_id'
      }, _vm.additionalParams),
      "item-text": _vm.itemText,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "error-messages": _vm.errorMessages
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      },
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var _item$initiator_data;
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-block py-2"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.shipment_id) + " - " + _vm._s(item.delivery_date) + " "), item.recipient_data ? [_vm._v(" - " + _vm._s(item.recipient_data.name))] : _vm._e()], 2), _c('div', [(_item$initiator_data = item.initiator_data) !== null && _item$initiator_data !== void 0 && _item$initiator_data.name ? [_vm._v(" " + _vm._s(item.initiator_data.name) + " - ")] : _vm._e(), _vm._v(" " + _vm._s(item.products_count) + " " + _vm._s(item.products_count > 1 ? _vm.$translate("products_count") : _vm.$translate("product_count")) + " - " + _vm._s(item.items_count) + " " + _vm._s(item.items_count > 1 ? _vm.$translate("items_count") : _vm.$translate("item_count")) + " ")], 2)])];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }